export enum Metered {
  Unknown = 0, // The metered status is unknown
  Yes = 1, // Metered, the value was explicitly configured
  No = 2, // Not metered, the value was explicitly configured
  GuessYes = 3, // Metered, the value was guessed
  GuessNo = 4, // Not metered, the value was guessed
}
